import { useEffect, useState } from 'react';

const consultar = (consulta: string): boolean =>
  typeof window !== 'undefined' &&
  typeof window.matchMedia === 'function' &&
  window.matchMedia(consulta).matches;

/**
 * Si la pantalla es ancha (por omisión, 1024 px o más). Lo usan los asistentes de
 * Compite para mostrar el resumen al costado sólo cuando entra.
 *
 * Sin `matchMedia` (jsdom en las pruebas) dice que no: el resumen no se dibuja y
 * no repite en el DOM los textos que las pruebas buscan una sola vez.
 */
export function usePantallaAncha(consulta = '(min-width: 1024px)'): boolean {
  const [ancha, setAncha] = useState(() => consultar(consulta));
  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(consulta);
    const alCambiar = () => setAncha(mq.matches);
    alCambiar();
    mq.addEventListener('change', alCambiar);
    return () => mq.removeEventListener('change', alCambiar);
  }, [consulta]);
  return ancha;
}
